import { AreaOfUse } from '../../../../core/model/area-of-use.model';

// Traverses through each Area of Use category and it's subcategories and returns array of all categories
export function getAllAreaOfUseCategories(areaOfUseCategories: AreaOfUse[]): AreaOfUse[] {
  const allAreaOfUseCategories = new Array<AreaOfUse>();
  areaOfUseCategories.forEach((category) => {
    if (!!category.subCategories) {
      allAreaOfUseCategories.push(...getAllAreaOfUseCategories(category.subCategories));
    }
    allAreaOfUseCategories.push(category);
  });
  return allAreaOfUseCategories;
}
